<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->
              <v-btn-toggle small v-model="toggle_tingkat" class="mr-3" multiple dark>                
                <v-btn round small v-for="(tingkat) in tingkats" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
              </v-btn-toggle>
             
              <v-btn color="blue" @click="save()" dark>
                <v-icon>save</v-icon> Simpan
              </v-btn>  
              </router-link>              
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0 tabular">
              <v-data-table
                
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"                            
                v-model="complex.selected"
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                <template slot="items" slot-scope="props">
                  <td>{{ props.index+1 }}</td>
                  <!--<td>{{ props.item.calon.user_id }}</td>-->
                  <td>{{ props.item.nama }}</td>
                  <td>{{ props.item.telepon }}</td>  
                  <td v-if="tingkats.length > 0">{{ tingkats.find(x=>x.id===props.item.jurusan_id) ? tingkats.find(x=>x.id===props.item.jurusan_id).description : tingkats.find(x=>x.id===props.item.tingkat_id).description}}</td>                  
                  <!--<td>{{ props.item.lahir_tempat +', '+ $moment(props.item.lahir_tanggal).format('DD/MM/YYYY') }}</td>-->
                  <template v-for="(ujian, n) in props.item.tertulisDtls">
                    <td v-bind:key="n" style="width:180px">
                      <v-text-field box type="number" @keyup="setData(props.item)" hide-details v-bind:label="ujian.matpel_nama" v-model="ujian.value"></v-text-field>
                    </td>
                  </template>
                  <template v-for="(i, key) in (3 - props.item.tertulisDtls.length)">
                    <td></td>
                  </template>
                  <td class="subheading"><strong>{{ props.item.calonTest? props.item.calonTest.tertulis:null }}</strong></td>
                </template>
              </v-data-table>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/admin/models/Calon';   

var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({        
        search   : '',
        loading  : true,
        toggle_tingkat : [],
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              //{ text: 'ID',   value: 'id'  },
              { text: 'Nama', value: 'nama'},              
              { text: 'Telepon', value: 'telepon'}, 
              { text: 'Tingkat', value: 'tingkat_id'},              
              { text: 'Matpel 1', value:'', sortable:false, align:'center'},
              { text: 'Matpel 2', value:'', sortable:false, align:'center'},
              { text: 'Matpel 3', value:'', sortable:false, align:'center'},
              { text: 'Total', value:'calonTest.tertulis',}
            ],
            items: []
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        data     : [],
    }),  
    watch:{
      toggle_tingkat(newArr){this.init();}
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});
      this.init(); 
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'black';}
        },
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }     
            let tingkat = [], jurusan = [];
            this.toggle_tingkat.forEach(ar=>{
              if(ar <= 3){tingkat.push(ar);} 
              else if(ar === 7){tingkat.push(ar);}
              else{jurusan.push(ar);}
            });
            this.loading = true;
            model.indexUjian({'UserCalonSearch[tingkat_id]':tingkat,'UserCalonSearch[jurusan_id]':jurusan}).then(data => {      
                this.complex.items = data; 
                this.loading = false;                
            });                                         
        },    
        
        save(){
          model.saveUjian({data:this.data}).then((res)=>{
            if(res.status === 200){
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                              
              this.init();
            }
          });
        },
        
        setData(fm){
          let test = this.data.find(x=>x.id === fm.id);
          let tertulis = 0;
          fm.tertulisDtls.forEach(ujian=>{
            tertulis += parseFloat(ujian.value);
          });
          if(test){
            test.tertulisDtls = fm.tertulisDtls;     
            test.tertulis     = tertulis;
          }else{
            this.data.push({id:fm.id, tertulis:tertulis, tertulisDtls:fm.tertulisDtls});
          }
          fm.calonTest.tertulis = tertulis;
        }
    }
}
</script>
<style>
.v-radio label{font-size:13px}  
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 5px 0 9px
}
</style>